export default __webpack_public_path__ + "static/media/STL_Predispatch_Adv.72c60b0a.pdf";